import{createContext as o,useContext as t}from"react";const r=o(Symbol("User Context default value"));function e(){const o=t(r);if("symbol"==typeof o)throw new Error("no value provided for context");return o}export{r as B,e as u};
